import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

export default function LanguageSwitcher({ variant = 'default' }) {
  const { lang, toggleLang, t } = useTranslation();

  if (variant === 'compact') {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleLang}
        className="flex items-center gap-1.5 text-xs font-medium px-2 py-1 rounded-full border border-gray-200 hover:border-emerald-400 hover:bg-emerald-50 transition-all"
        data-testid="language-switcher"
        title={t('lang.switchTo')}
      >
        <Globe size={14} />
        <span>{lang === 'fr' ? 'EN' : 'FR'}</span>
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLang}
      className="flex items-center gap-2 font-medium"
      data-testid="language-switcher"
    >
      <Globe size={16} />
      <span>{lang === 'fr' ? 'EN' : 'FR'}</span>
    </Button>
  );
}
